import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isCloudflareWorkers, isNodeJs } from './global.js';
import crypto from './webcrypto.js';
import { JOSENotSupported } from '../util/errors.js';
import { decode as base64url } from './base64url.js';

function subtleMapping(jwk) {
  var algorithm;
  var keyUsages;

  switch (jwk.kty) {
    case 'oct':
      {
        switch (jwk.alg) {
          case 'HS256':
          case 'HS384':
          case 'HS512':
            algorithm = {
              name: 'HMAC',
              hash: {
                name: "SHA-".concat(jwk.alg.substr(-3))
              }
            };
            keyUsages = ['sign', 'verify'];
            break;

          case 'A128CBC-HS256':
          case 'A192CBC-HS384':
          case 'A256CBC-HS512':
            throw new JOSENotSupported("".concat(jwk.alg, " keys cannot be imported as CryptoKey instances"));

          case 'A128GCM':
          case 'A192GCM':
          case 'A256GCM':
          case 'A128GCMKW':
          case 'A192GCMKW':
          case 'A256GCMKW':
            algorithm = {
              name: 'AES-GCM'
            };
            keyUsages = ['encrypt', 'decrypt'];
            break;

          case 'A128KW':
          case 'A192KW':
          case 'A256KW':
            algorithm = {
              name: 'AES-KW'
            };
            keyUsages = ['wrapKey', 'unwrapKey'];
            break;

          case 'PBES2-HS256+A128KW':
          case 'PBES2-HS384+A192KW':
          case 'PBES2-HS512+A256KW':
            algorithm = {
              name: 'PBKDF2'
            };
            keyUsages = ['deriveBits'];
            break;

          default:
            throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }

        break;
      }

    case 'RSA':
      {
        switch (jwk.alg) {
          case 'PS256':
          case 'PS384':
          case 'PS512':
            algorithm = {
              name: 'RSA-PSS',
              hash: {
                name: "SHA-".concat(jwk.alg.substr(-3))
              }
            };
            keyUsages = jwk.d ? ['sign'] : ['verify'];
            break;

          case 'RS256':
          case 'RS384':
          case 'RS512':
            algorithm = {
              name: 'RSASSA-PKCS1-v1_5',
              hash: {
                name: "SHA-".concat(jwk.alg.substr(-3))
              }
            };
            keyUsages = jwk.d ? ['sign'] : ['verify'];
            break;

          case 'RSA-OAEP':
          case 'RSA-OAEP-256':
          case 'RSA-OAEP-384':
          case 'RSA-OAEP-512':
            algorithm = {
              name: 'RSA-OAEP',
              hash: {
                name: "SHA-".concat(parseInt(jwk.alg.substr(-3), 10) || 1)
              }
            };
            keyUsages = jwk.d ? ['decrypt', 'unwrapKey'] : ['encrypt', 'wrapKey'];
            break;

          default:
            throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }

        break;
      }

    case 'EC':
      {
        switch (jwk.alg) {
          case 'ES256':
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-256'
            };
            keyUsages = jwk.d ? ['sign'] : ['verify'];
            break;

          case 'ES384':
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-384'
            };
            keyUsages = jwk.d ? ['sign'] : ['verify'];
            break;

          case 'ES512':
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-521'
            };
            keyUsages = jwk.d ? ['sign'] : ['verify'];
            break;

          case 'ECDH-ES':
          case 'ECDH-ES+A128KW':
          case 'ECDH-ES+A192KW':
          case 'ECDH-ES+A256KW':
            algorithm = {
              name: 'ECDH',
              namedCurve: jwk.crv
            };
            keyUsages = jwk.d ? ['deriveBits'] : [];
            break;

          default:
            throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }

        break;
      }

    case (isCloudflareWorkers() || isNodeJs()) && 'OKP':
      if (jwk.alg !== 'EdDSA') {
        throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }

      switch (jwk.crv) {
        case 'Ed25519':
          algorithm = {
            name: 'NODE-ED25519',
            namedCurve: 'NODE-ED25519'
          };
          keyUsages = jwk.d ? ['sign'] : ['verify'];
          break;

        case isNodeJs() && 'Ed448':
          algorithm = {
            name: 'NODE-ED448',
            namedCurve: 'NODE-ED448'
          };
          keyUsages = jwk.d ? ['sign'] : ['verify'];
          break;

        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "crv" (Subtype of Key Pair) Parameter value');
      }

      break;

    default:
      throw new JOSENotSupported('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }

  return {
    algorithm: algorithm,
    keyUsages: keyUsages
  };
}

var parse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwk) {
    var _crypto$subtle2;

    var _a, _b, _subtleMapping, algorithm, keyUsages, rest, _crypto$subtle, keyData;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _subtleMapping = subtleMapping(jwk), algorithm = _subtleMapping.algorithm, keyUsages = _subtleMapping.keyUsages;
            rest = [algorithm, (_a = jwk.ext) !== null && _a !== void 0 ? _a : false, (_b = jwk.key_ops) !== null && _b !== void 0 ? _b : keyUsages];

            if (!(algorithm.name === 'PBKDF2')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", (_crypto$subtle = crypto.subtle).importKey.apply(_crypto$subtle, ['raw', base64url(jwk.k)].concat(rest)));

          case 4:
            keyData = _objectSpread({}, jwk);
            delete keyData.alg;
            return _context.abrupt("return", (_crypto$subtle2 = crypto.subtle).importKey.apply(_crypto$subtle2, ['jwk', keyData].concat(rest)));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function parse(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default parse;